import styled from 'styled-components/macro';
import { baseText } from './colorConstants';
import * as colors from 'components/common/colorConstants';

export const mediumScreens = '1024px';
export const smallScreens = '800px';
export const extraSmallScreens = '600px';
export const lowHeightScreens = '569px';
export const mediumHeightScreens = '650px';
export const largeWidthScreen = '1300px';

export const DefaultText = styled.div`
  font-size: 12px;

  @media screen and (max-width: ${mediumScreens}) {
    font-size: 10px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 9.8px;
  }
`;

export const TicketTextRegular = styled(DefaultText)`
  font-family: 'Lato-Regular', sans-serif;
  white-space: normal;
  color: ${(props) => (props.selected ? 'white' : colors.black4)};
`;

export const TicketTextBold = styled(DefaultText)`
  font-family: 'Lato-Bold', sans-serif;
  white-space: nowrap;
  color: ${(props) => (props.selected ? 'white' : colors.black4)};
`;

export const HeaderText = styled.div`
  color: ${colors.black4};
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
`;

export const ButtonText = styled.button`
  font-family: 'Lato-Regular', sans-serif;
  font-size: 10px;

  @media screen and (max-width: ${mediumScreens}) {
    font-size: 9px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 9px;
  }
`;

export const DateRangePickerText = styled.div`
  .DateRangePicker {
    .DateRangePickerInput {
      .DateInput {
        font-family: 'Lato-Regular', sans-serif;
        line-height: 10px;
        width: 60px;

        .DateInput_input {
          font-size: 10px;
        }
      }

      .DateRangePickerInput_arrow {
        .DateRangePickerInput_arrow_svg {
          width: 10px;
        }
      }
    }
  }

  @media screen and (max-width: ${mediumScreens}) {
    .DateRangePicker {
      .DateRangePickerInput {
        .DateInput {
          line-height: 9px;
          width: 50px;

          .DateInput_input {
            font-size: 9px;
          }
        }
      }

      .DateRangePickerInput_arrow {
        .DateRangePickerInput_arrow_svg {
          width: 9px;
        }
      }
    }
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    .DateRangePicker {
      .DateRangePickerInput {
        .DateInput {
          line-height: 9px;
          width: 50px;

          .DateInput_input {
            font-size: 9px;
          }
        }
      }

      .DateRangePickerInput_arrow {
        .DateRangePickerInput_arrow_svg {
          width: 9px;
        }
      }
    }
  }
`;

export const SelectHolderText = styled.div`
  .Select {
    .Select-multi-value-wrapper {
      .Select-input,
      .Select-value,
      .Select-placeholder {
        font-size: 10px;
      }
    }

    .Select-menu-outer {
      .Select-menu {
        .Select-noresults,
        .Select-option {
          font-size: 10px;
        }
      }
    }
  }

  @media screen and (max-width: ${mediumScreens}) {
    .Select {
      .Select-multi-value-wrapper {
        .Select-input,
        .Select-value,
        .Select-placeholder {
          font-size: 9px;
        }
      }

      .Select-menu-outer {
        .Select-menu {
          .Select-noresults,
          .Select-option {
            font-size: 9px;
          }
        }
      }
    }
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    .Select {
      .Select-multi-value-wrapper {
        .Select-input,
        .Select-value,
        .Select-placeholder {
          font-size: 9px;
        }
      }

      .Select-menu-outer {
        .Select-menu {
          .Select-noresults,
          .Select-option {
            font-size: 9px;
          }
        }
      }
    }
  }
`;

export const TicketsFiltersInputText = styled.input`
  font-family: 'Lato-Regular', sans-serif;
  font-size: 10px;

  @media screen and (max-width: ${mediumScreens}) {
    font-size: 9px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 9px;
  }
`;

export const TicketsFiltersLabelsText = styled.span`
  font-family: 'Lato-Regular', sans-serif;
  font-size: 10px;
  color: ${colors.black4};

  @media screen and (max-width: ${mediumScreens}) {
    font-size: 9px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 9px;
  }
`;

export const TicketsFiltersSelectText = styled.select`
  font-family: 'Lato-Regular', sans-serif;
  font-size: 10px;

  @media screen and (max-width: ${mediumScreens}) {
    font-size: 9px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 9px;
  }
`;

export const SearchResultsTableRow = styled.tr`
  font-size: 12px;

  @media screen and (max-width: ${mediumScreens}) {
    font-size: 10px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 9.8px;
  }
`;

export const TicketButtonsText = styled.button`
  font-size: 9.5px;

  @media screen and (max-width: ${mediumScreens}) {
    font-size: 7.5px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 6.5px;
  }
`;

export const ActionsTitleText = styled.div`
  font-size: 16px;
  line-height: 18px;

  @media screen and (max-width: ${mediumScreens}) {
    font-size: 12px;
    line-height: 13.5px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 12px;
    line-height: 10.5px;
  }
`;

export const FeedbackMessageText = styled.span`
  font-size: 12px;

  @media screen and (max-width: ${mediumScreens}) {
    font-size: 10px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 9px;
  }
`;

export const ActionsButtonsText = styled.button`
  font-size: 9.2px;
  font-family: 'Lato-Bold', sans-serif;

  @media screen and (max-width: ${mediumScreens}) {
    font-size: 6.9px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 7.1px;
  }
`;

export const TicketPaginationText = styled.div`
  font-size: 9.2px;
  font-family: 'Lato-Bold', sans-serif;

  @media screen and (max-width: ${mediumScreens}) {
    font-size: 6.9px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 7.1px;
  }
`;

export const NewMessageTextAreaHolder = styled.div`
  font-size: 12px;

  @media screen and (max-width: ${mediumScreens}) {
    font-size: 10px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 9px;
  }
`;

export const OrderActionTitleText = styled.div`
  font-family: Lato-Light, sans-serif;
  font-weight: lighter;
  color: ${baseText};

  font-size: 18px;
  line-height: 22px;

  @media screen and (max-width: ${mediumScreens}) {
    font-size: 14px;
    line-height: 16px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 12px;
    line-height: 14px;
  }
`;

export const OrderActionSubtitleText = styled.div`
  font-family: Lato, sans-serif;
  font-weight: normal;
  color: ${baseText};

  font-size: 14px;

  @media screen and (max-width: ${mediumScreens}) {
    font-size: 12px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 11px;
  }
`;

export const OrderActionAdditionalInfoText = styled.div`
  font-family: 'Lato-Bold', sans-serif;
  font-size: 10px;
  color: ${baseText};

  @media screen and (max-width: ${mediumScreens}) {
    font-size: 9px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 9px;
  }
`;

export const Header = styled.h1`
  font-family: 'Roboto', sans-serif;
  line-height: 18px;
  font-weight: 500;
  font-size: 16px;
  color: ${colors.black4};

  @media screen and (max-width: ${mediumScreens}) {
    font-size: 13px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 12px;
  }
`;

export const SubText = styled.h4`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 16px;
  color: ${colors.darkGray1};

  @media screen and (max-width: ${mediumScreens}) {
    font-size: 10px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 9px;
  }
`;

export const SubTitle = styled.h4`
  font: 500 9px 'Roboto', sans-serif;
  line-height: 14px;
  color: ${colors.darkGray1};
`;
